import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Row } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import Flatpickr from "react-flatpickr";
import { getEstablishmentList } from '../../../helpers/establishment/backend_helper';
import GeneralSelect from '../../../Components/General/Selects/GeneralSelect';
import { getFinalDestinationList } from '../../../helpers/residue/backend_helper';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import 'dayjs/locale/es-mx';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import OSelect from '../../../Components/OElements/OSelect';
import useEstablishmentAssignationUser from '../../../Components/Hooks/useEstablishmentAssignationUser';

const OffcanvasContainer = ({ isOpen, toggle, filters, onSubmit }) => {
    const {
        establishments,
        establishmentsListSelect
    } = useEstablishmentAssignationUser();
    const [selectedDate, setSelectedDate] = useState(filters.dateRange);
    const [selectedEstablishment, setSelectedEstablishment] = useState(null);
    const [selectedFinalDestination, setSelectedFinalDestination] = useState(null);
    
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleEstablishmentSelected = (optionSelected) => {
        setSelectedEstablishment(optionSelected);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        
    };

    const handleClearFilters = () => {
        onSubmit({});
        validation.resetForm();
    };

    const validation = useFormik({
        // enableReinitialize: use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            establishment_id: '',
            final_destination_id: '',
            date_range: []
        },
        validationSchema: Yup.object({
            establishment_id: Yup.string(),
            final_destination_id: Yup.string(),
            date_range: Yup.array()
        }),
        onSubmit: async (values) => {
            const filteredFilters = {};
            if (values.establishment_id) filteredFilters.establishment_id = values.establishment_id;
            if (values.final_destination_id) filteredFilters.final_destination_id = values.final_destination_id;
            if (values.date_range) filteredFilters.start_date = values.date_range[0];
            if (values.date_range) filteredFilters.end_date = values.date_range[1];
            onSubmit(filteredFilters);
            toggle();
        }
    });

    useEffect(() => {
        if(isOpen){
            validation.setFieldValue('date_range', (
                filters.start_date &&
                filters.end_date
                    ? [filters.start_date, filters.end_date] 
                    : []
            ));
        }
    }, [isOpen])

    return (
        <Offcanvas
            isOpen={isOpen}
            direction="end"
            toggle={toggle}
            className="border-bottom"
        >
            <OffcanvasHeader toggle={toggle}>
                Filtros
            </OffcanvasHeader>
            <OffcanvasBody className="p-3 overflow-hidden">
                <SimpleBar style={{ height: "100vh" }}>
                    <Form
                        className=''
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                        }}
                    >
                        <Row className='g-3'>
                            <Col lg={12}>
                                <OSelect
                                    key={`establishment_id${filters?.establishment_id}` || ''}
                                    label='Establecimiento'
                                    id='establishment_id'
                                    name='establishment_id'
                                    value={
                                        filters?.establishment_id || ''
                                    }
                                    handleLabelOptions={(item) => `${item.name}`}
                                    onSelect={setSelectedEstablishment}
                                    requestApi={null}
                                    itemsSelect={establishmentsListSelect}
                                    validation={validation}
                                />
                            </Col>
                            <Col lg={12}>
                                <OSelect
                                    key={`final_destination_id${filters?.final_destination_id}` || ''}
                                    label='Destino Final'
                                    id='final_destination_id'
                                    name='final_destination_id'
                                    value={filters?.final_destination_id || ''}
                                    onSelect={setSelectedFinalDestination}
                                    requestApi={() => getFinalDestinationList({})}
                                    validation={validation}
                                />
                            </Col>
                            <Col sm={12}>
                                <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                                    <DatePickerInput
                                        key={`date_range`}
                                        type='range'
                                        label='Rango de fecha'
                                        id='date_range'
                                        name='date_range'
                                        placeholder="Seleccione un rango"
                                        value={(validation.values.date_range)}
                                        onChange={(date) => {
                                            const dates = date.filter(item => item != null);
                                            validation.setFieldValue("date_range", (
                                                dates.length
                                                    ? dates
                                                    : []
                                            ));
                                        }}
                                        onBlur={validation.handleBlur}
                                        valueFormat='DD-MM-YYYY'
                                        // maxDate={new Date()}
                                        error={
                                            validation.touched['date_range'] &&
                                            validation.errors['date_range']
                                                ? validation.errors['date_range'] : ''
                                        }
                                        clearable={true}
                                        
                                    />
                                </DatesProvider>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col>
                                <div className="hstack gap-2 mt-4">
                                    <button type='submit' className='btn btn-label btn-primary'><i className="ri-filter-fill label-icon"></i> Filtrar </button>
                                    <button type='button' className='btn btn-label btn-primary' onClick={handleClearFilters}><i className="ri-filter-off-fill label-icon"></i> Limpiar</button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </SimpleBar>
            </OffcanvasBody>
        </Offcanvas >
    );
};

export default OffcanvasContainer;
